// component
import SvgColor from '../../../components/svg-color';
import { Payment as PaymentIcon, AccountBalance as RoyaltyIcon, Receipt as InvoiceIcon, Autorenew as StatusIcon} from '@mui/icons-material';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import MobiledataOffIcon from '@mui/icons-material/MobiledataOff';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import LanIcon from '@mui/icons-material/Lan';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import BadgeIcon from '@mui/icons-material/Badge';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import { ROLES, STAKEHOLDERTYPE ,STAKEHOLDERSUBTYPE } from '../../../../common/constants';


// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;



  
  export const navConfig = [
  
  {
    role: ROLES?.RegInCharge,
    modules : [
      {
        title: 'Dashboard',
        path: '/registrationHome/dashboard',
        icon: <DashboardIcon />,
        order: 1,
      },
      {
        title: 'Pre-Registration',
        path: '/registrationHome/preregistration',
        icon: <HistoryEduIcon/>,
        order: 2,
      },
      {
        title: 'Shortlisting',
        path: '/registrationHome/shortlisting',
        icon: <MobiledataOffIcon />,
        order: 3,
      },
      {
        title: 'Onboarding',
        path: '/registrationHome/onboarding',
        icon: <HowToRegIcon />,
        order: 4,
      },
      {
        title: 'Mapping',
        path: '/registrationHome/mapping',
        icon: <LanIcon />,
        order: 5,
      },
      {
        title: 'Card Generation',
        path: '/registrationHome/cardGeneration',
        icon: <CreditCardIcon />,
        order: 6,
      },
    ]
  },
  {
    role: ROLES?.RegAssistant,
    modules : [
      {
        title: 'Pre-Registration',
        path: '/registrationHome/preregistration',
        icon: <HistoryEduIcon />,
        order: 2,

      }
    ]
  },
  {
    role: ROLES?.RegistrationScruitnizer,
    modules : [
      {
        title: 'Dashboard',
        path: '/registrationHome/dashboard',
        icon: <DashboardIcon />,
        order: 1,
      }
    ]
  },
 
  {
    role: ROLES?.LeadRegScrutinizer,
    modules : [
      {
        title: 'Dashboard',
        path: '/registrationHome/dashboard',
        icon: <DashboardIcon />,
        order: 1,
      }
    ]
  },
  
];


export const navConfigStakeholder = [
  {
  stakeholderType : STAKEHOLDERTYPE?.HIT,
  modules : [
  {
    title: 'Dashboard',
    path: '/dashboardHome/dashboardStakeHolder',
    icon: <DashboardIcon />,
    order: 1,
    

  },
  {
    title: 'HelpDesk',
    path: '/dashboardHome/requests',
    icon: <AnnouncementIcon />,
    order: 2,
    children : [
      {
        title: 'Requests',
        path: '/dashboardHome/requests',
        icon: <AssessmentIcon />,
      },
      {
        title: 'FAQs',
        path: '/dashboardHome/faqs',
        icon: <AssessmentIcon />,
      },
    ]
  },
  {
    title: 'Demand',
    path: '/dashboardHome/workflowStatusList',
    icon: <AssessmentIcon />,
    order: 3,

  },
  {
    title: 'PIT',
    path: '/dashboardHome/trialScreen',
    icon: <AutoModeIcon />,
    order: 4,
    children : [
      // {
      //   title: "Home",
      //   path: '/dashboardHome/trialScreen',
      //   icon: <AssessmentIcon />,
      // },
      {
        title: "Weekly Schedule",
        path: '/dashboardHome/GhtSchedule',
        icon: <AssessmentIcon />,
      },
     
      {
        title: "Consignment Pick-Up/Tracker",
        path: '/dashboardHome/ConsignmentPickUp',
        icon: <AssessmentIcon />,
      },
      {
        title: "Invoices",
        path: '/dashboardHome/invoiceList',
        icon: <AssessmentIcon />,
      },
      {
        title: "GRN's",
        path: '/dashboardHome/grnList',
        icon: <AssessmentIcon />,
      },
      {
        title: "Delivery Chalans",
        path: '/dashboardHome/deliveryChalanList',
        icon: <AssessmentIcon />,
      },
      {
        title: "Consignment List",
        path: '/dashboardHome/consignmentList',
        icon: <AssessmentIcon />,
      },
    ]
  },
  {
    title: 'Payment Status',
    path: '/dashboardHome/PaymentStatusStakeholderUser',
    icon: <PaymentIcon />,
    order: 5,

  },
  {
    title: 'Registration Details',
    path: '/dashboardHome/registrationDetailsHit',
    icon: <HowToRegIcon />,
    order: 6,

  },
  {
    title: 'Resource',
    path: '/dashboardHome/viewKnowledgeManagement',
    icon: <BadgeIcon />,
    order: 7,
    children : [
      {
        title: 'View Knowledge Management',
        path: '/dashboardHome/viewKnowledgeManagement',
        icon: <AssessmentIcon />,
      },
    ]
  },
],
  },
  {
    stakeholderType : STAKEHOLDERTYPE?.Transporter,
    modules : [
      {
        title: 'Dashboard',
        path: '/dashboardHome/dashboardStakeHolder',
        icon: <DashboardIcon />,
        order: 1,
        
    
      },
      {
        title: 'HelpDesk',
        path: '/dashboardHome/requests',
        icon: <AnnouncementIcon />,
        order: 2,
        children : [
          {
            title: 'Requests',
            path: '/dashboardHome/requests',
            icon: <AssessmentIcon />,
          },
          {
            title: 'FAQs',
            path: '/dashboardHome/faqs',
            icon: <AssessmentIcon />,
          },
        ]
      },
      {
        title: 'Demand',
        path: '/dashboardHome/workflowStatusList',
        icon: <AssessmentIcon />,
        order: 3,
    
      },
      {
        title: 'PIT',
        path: '/dashboardHome/trialScreen',
        icon: <AutoModeIcon />,
        order: 4,
        children : [
          // {
          //   title: "Home",
          //   path: '/trialScreen'
          // },
          {
            title: "Weekly Schedule",
            path: '/dashboardHome/GhtSchedule',
            icon: <AutoModeIcon />,
          },
          {
            title: "Consignment Creation",
            path: '/dashboardHome/ChippingConsignmentCreation',
            icon: <AutoModeIcon />,
          },
          {
            title: "Invoices",
            path: '/dashboardHome/invoiceList',
            icon: <AutoModeIcon />,
          },
          {
            title: "GRN's",
            path: '/grnList',
          icon: <AutoModeIcon />,
          },
          {
            title: "Delivery Chalans",
            path: '/dashboardHome/deliveryChalanList',
            icon: <AutoModeIcon />,
            
          },
          // {
          //   title: "Bidding Schedule Selection",
          //   path: '/dashboardHome/biddingSelection',
          //   icon: <AutoModeIcon />,
          // },
    
          // {
          //   title: "Bidding Schedule Approval",
          //   path: '/dashboardHome/biddingApproval',
          //   icon: <AutoModeIcon />,
          // },
          {
            title: "Bidding",
            path: '/dashboardHome/bidding',
            icon: <AutoModeIcon />,
          },
          {
            title: "Consignment List",
            path: '/dashboardHome/consignmentList',
            icon: <AssessmentIcon />,
          },
          // {
          //   title: "Bidding Approval",
          //   path: '/dashboardHome/biddingApprovalList',
          //   icon: <AutoModeIcon />,
          // },
        ]
      },
      {
        title: 'Payment Status',
        path: '/dashboardHome/PaymentStatusStakeholderUser',
        icon: <PaymentIcon />,
        order: 5,
     
      },
    {
      title: 'Registration Details',
      path: '/dashboardHome/registrationDetailsTransporter',
      icon: <HowToRegIcon />,
      order: 6,
  
    },
    {
      title: 'Resource',
      path: '/dashboardHome/viewKnowledgeManagement',
      icon: <BadgeIcon />,
      order: 7,
      children : [
        {
          title: 'View Knowledge Management',
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <AssessmentIcon />,
        },
      ]
    },
  ],
    },
    {
      stakeholderType : STAKEHOLDERTYPE?.LLE,
      modules : [
        {
          title: 'Dashboard',
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,
          
      
        },
        {
          title: 'HelpDesk',
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children : [
            {
              title: 'Requests',
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: 'FAQs',
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: 'Demand',
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,
      
        },
        {
          title: 'PIT',
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
         children : [
          // {
          //   title: "Home",
          //   path: '/dashboardHome/trialScreen',
          //   icon: <AutoModeIcon />,
          // },
          {
            title: "STO",
            path: '/dashboardHome/stoList',
            icon: <AutoModeIcon />,
          },
          {
            title: 'Weekly Schedule',
            path: '/dashboardHome/lpiSchedule',
            icon: <AutoModeIcon />,
          },
          {
            title: 'Chipping Orders',
            path: '/dashboardHome/chippingOrders',
            icon: <AutoModeIcon />,
          },
          {
            title: "ASN's",
            path: '/dashboardHome/AsnGRn',
            icon: <AutoModeIcon />,
          },
          {
            title: "GRN's",
            path: '/dashboardHome/grnList',
            icon: <AutoModeIcon />,
          },
          {
            title: "GRN Approval",
            path: '/dashboardHome/grnApprove',
            icon: <AutoModeIcon />,
          },
          {
            title: "LLE Pickup/Tracker",
            path: '/dashboardHome/inventoryType',
            icon: <AutoModeIcon />,
          },
          {
            title: "Invoices",
            path: '/dashboardHome/invoiceList',
            icon: <AutoModeIcon />,
          },
          {
            title: "Delivery Chalans",
            path: '/dashboardHome/deliveryChalanList',
            icon: <AutoModeIcon />,
          },
          {
            title: "Inventory Ledger",
            path: '/dashboardHome/LnvLedger',
            icon: <AutoModeIcon />,
          },
          {
            title: "Consignment List",
            path: '/dashboardHome/consignmentList',
            icon: <AssessmentIcon />,
          }
         ]
        },
        {
          title: 'Payment Status',
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,
      
        },
      {
        title: 'Registration Details',
        path: '/dashboardHome/registrationDetailsLle',
        icon: <HowToRegIcon />,
        order: 6,
    
      },
      {
        title: 'Resource',
        path: '/dashboardHome/viewKnowledgeManagement',
        icon: <BadgeIcon />,
        order: 7,
        children : [
          {
            title: 'View Knowledge Management',
            path: '/dashboardHome/viewKnowledgeManagement',
            icon: <AssessmentIcon />,
          },
        ]
      },
    ],
      },
      {
        stakeholderType : STAKEHOLDERTYPE?.InterimStorageOperator,
        modules : [
          {
            title: 'Dashboard',
            path: '/dashboardHome/dashboardStakeHolder',
            icon: <DashboardIcon />,
            order: 1,
            
        
          },
          {
            title: 'HelpDesk',
            path: '/dashboardHome/requests',
            icon: <AnnouncementIcon />,
            order: 2,
            children : [
              {
                title: 'Requests',
                path: '/dashboardHome/requests',
                icon: <AssessmentIcon />,
              },
              {
                title: 'FAQs',
                path: '/dashboardHome/faqs',
                icon: <AssessmentIcon />,
              },
            ]
          },
          {
            title: 'Demand',
            path: '/dashboardHome/workflowStatusList',
            icon: <AssessmentIcon />,
            order: 3,
        
          },
          {
            title: 'PIT',
            path: '/dashboardHome/trialScreen',
            icon: <AutoModeIcon />,
            order: 4,
            children: [
              // {
              //   title: "Home",
              //   path: '/dashboardHome/trialScreen',
              //   icon: <AutoModeIcon />,
              // },
              {
                title: "STO",
                path: '/dashboardHome/stoList',
                icon: <AutoModeIcon />,
              },
              {
                title: 'Weekly Schedule',
                path: '/dashboardHome/lpiSchedule',
                icon: <AutoModeIcon />,
              },
              {
                title: 'Chipping Orders',
                path: '/dashboardHome/chippingOrders',
                icon: <AutoModeIcon />,
              },
              {
                title: "ASN's",
                path: '/dashboardHome/asnGRN',
                icon: <AutoModeIcon />,
              },
              {
                title: "GRN's",
                path: '/dashboardHome/grnList',
                icon: <AutoModeIcon />,
              },
              {
                title: "LLE RB Pickup/Tracker",
                path: '/dashboardHome/inventoryType',
                icon: <AutoModeIcon />,
              },
              {
                title: "Delivery Chalans",
                path: '/dashboardHome/deliveryChalanList',
                icon: <AutoModeIcon />,
              },
              {
                title: "Inventory Ledger",
                path: '/dashboardHome/LnvLedger',
                icon: <AutoModeIcon />,
              },
              {
                title: "Consignment List",
                path: '/dashboardHome/consignmentList',
                icon: <AssessmentIcon />,
              }
            ]
        
          },
          {
            title: 'Payment Status',
            path: '/dashboardHome/PaymentStatusStakeholderUser',
            icon: <PaymentIcon />,
            order: 5,
        
          },
        {
          title: 'Registration Details',
          path: '/dashboardHome/registrationDetailsTempStorage',
          icon: <HowToRegIcon />,
          order: 6,
      
        },
        {
          title: 'Resource',
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children : [
            {
              title: 'View Knowledge Management',
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
        },
    {
      stakeholderType : STAKEHOLDERSUBTYPE.INDIVIDUAL,
      modules : [
        {
          title: 'Dashboard',
          path: '/dashboardHome/dashboardStakeHolder',
          icon: <DashboardIcon />,
          order: 1,
          
      
        },
        {
          title: 'HelpDesk',
          path: '/dashboardHome/requests',
          icon: <AnnouncementIcon />,
          order: 2,
          children : [
            {
              title: 'Requests',
              path: '/dashboardHome/requests',
              icon: <AssessmentIcon />,
            },
            {
              title: 'FAQs',
              path: '/dashboardHome/faqs',
              icon: <AssessmentIcon />,
            },
          ]
        },
        {
          title: 'Demand',
          path: '/dashboardHome/workflowStatusList',
          icon: <AssessmentIcon />,
          order: 3,
      
        },
        {
          title: 'PIT',
          path: '/dashboardHome/trialScreen',
          icon: <AutoModeIcon />,
          order: 4,
          children:[
            // {
            //   title: "Home",
            //   path: '/dashboardHome/trialScreen',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: "POs",
              path: '/dashboardHome/poList',
              icon: <AutoModeIcon />,
            },
            {
              title: "Weekly Schedule",
              path: '/dashboardHome/GhtSchedule',
              icon: <AutoModeIcon />,
            },
            {
              title: "Invoices",
              path: '/dashboardHome/invoiceList',
              icon: <AutoModeIcon />,
            },
            // {
            //   title: "Monthly PO",
            //   path: '/dashboardHome/PoQtyApproval',
            //   icon: <AutoModeIcon />,
            // },
            {
              title: "Consignment List",
              path: '/dashboardHome/consignmentList',
              icon: <AssessmentIcon />,
            }
          ]
      
        },
        {
          title: 'Payment Status',
          path: '/dashboardHome/PaymentStatusStakeholderUser',
          icon: <PaymentIcon />,
          order: 5,
      
        },
      {
        title: 'Registration Details',
        path: '/dashboardHome/registrationDetails',
        icon: <HowToRegIcon />,
        order: 6,
    
      },
      {
        title: 'Resource',
        path: '/dashboardHome/viewKnowledgeManagement',
        icon: <BadgeIcon />,
        order: 7,
        children : [
          {
            title: 'View Knowledge Management',
            path: '/dashboardHome/viewKnowledgeManagement',
            icon: <AssessmentIcon />,
          },
          {
            title: 'Plantation Batch',
            path: '/dashboardHome/plantationHome',
            icon: <AssessmentIcon />,
          },
        ]
      },
    ],
      },
      {
        stakeholderType : STAKEHOLDERSUBTYPE.JFMC,
        modules : [
          {
            title: 'Dashboard',
            path: '/dashboardHome/dashboardStakeHolder',
            icon: <DashboardIcon />,
            order: 1,
            
        
          },
          {
            title: 'HelpDesk',
            path: '/dashboardHome/requests',
            icon: <AnnouncementIcon />,
            order: 2,
            children : [
              {
                title: 'Requests',
                path: '/dashboardHome/requests',
                icon: <AssessmentIcon />,
              },
              {
                title: 'FAQs',
                path: '/dashboardHome/faqs',
                icon: <AssessmentIcon />,
              },
            ]
          },
          {
            title: 'Demand',
            path: '/dashboardHome/workflowStatusList',
            icon: <AssessmentIcon />,
            order: 3,
        
          },
          {
            title: 'PIT',
            path: '/dashboardHome/trialScreen',
            icon: <AutoModeIcon />,
            order: 4,
            children:[
              // {
              //   title: "Home",
              //   path: '/dashboardHome/trialScreen',
              //   icon: <AutoModeIcon />,
              // },
              {
                title: "POs",
                path: '/dashboardHome/poList',
                icon: <AutoModeIcon />,
              },
              {
                title: "Weekly Schedule",
                path: '/dashboardHome/GhtSchedule',
                icon: <AutoModeIcon />,
              },
              {
                title: "Invoices",
                path: '/dashboardHome/invoiceList',
                icon: <AutoModeIcon />,
              },
              // {
              //   title: "Monthly PO",
              //   path: '/dashboardHome/PoQtyApproval',
              //   icon: <AutoModeIcon />,
              // },
            ]
          },
          {
            title: 'Payment Status',
            path: '/dashboardHome/PaymentStatusStakeholderUser',
            icon: <PaymentIcon />,
            order: 5,
        
          },
        {
          title: 'Registration Details',
          path: '/dashboardHome/registrationDetails',
          icon: <HowToRegIcon />,
          order: 6,
      
        },
        {
          title: 'Resource',
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children : [
            {
              title: 'View Knowledge Management',
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: 'Plantation Batch',
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
        },
        {
          stakeholderType : STAKEHOLDERSUBTYPE.GROWER ,
          modules : [
            {
              title: 'Dashboard',
              path: '/dashboardHome/dashboardStakeHolder',
              icon: <DashboardIcon />,
              order: 1,
              
          
            },
            {
              title: 'HelpDesk',
              path: '/dashboardHome/requests',
              icon: <AnnouncementIcon />,
              order: 2,
              children : [
                {
                  title: 'Requests',
                  path: '/dashboardHome/requests',
                  icon: <AssessmentIcon />,
                },
                {
                  title: 'FAQs',
                  path: '/dashboardHome/faqs',
                  icon: <AssessmentIcon />,
                },
              ]
            },
            {
              title: 'Demand',
              path: '/dashboardHome/workflowStatusList',
              icon: <AssessmentIcon />,
              order: 3,
          
            },
            {
              title: 'PIT',
              path: '/dashboardHome/trialScreen',
              icon: <AutoModeIcon />,
              order: 4,
              children:[
                // {
                //   title: "Home",
                //   path: '/dashboardHome/trialScreen',
                //   icon: <AutoModeIcon />,
                // },
                {
                  title: "POs",
                  path: '/dashboardHome/poList',
                  icon: <AutoModeIcon />,
                },
                {
                  title: "Weekly Schedule",
                  path: '/dashboardHome/GhtSchedule',
                  icon: <AutoModeIcon />,
                },
                {
                  title: "Invoices",
                  path: '/dashboardHome/invoiceList',
                  icon: <AutoModeIcon />,
                },
                // {
                //   title: "Monthly PO",
                //   path: '/dashboardHome/PoQtyApproval',
                //   icon: <AutoModeIcon />,
                // },
                {
                  title: "Consignment List",
                  path: '/dashboardHome/consignmentList',
                  icon: <AssessmentIcon />,
                }
              ]
            },
            {
              title: 'Payment Status',
              path: '/dashboardHome/PaymentStatusStakeholderUser',
              icon: <PaymentIcon />,
              order: 5,
          
            },
          {
            title: 'Registration Details',
            path: '/dashboardHome/registrationDetails',
            icon: <HowToRegIcon />,
            order: 6,
        
          },
          {
            title: 'Resource',
            path: '/dashboardHome/viewKnowledgeManagement',
            icon: <BadgeIcon />,
            order: 7,
            children : [
              {
                title: 'View Knowledge Management',
                path: '/dashboardHome/viewKnowledgeManagement',
                icon: <AssessmentIcon />,
              },
              {
                title: 'Plantation Batch',
                path: '/dashboardHome/plantationHome',
                icon: <AssessmentIcon />,
              },
            ]
          },
        ],
          },
          {
            stakeholderType : STAKEHOLDERSUBTYPE.OTHER_GOV_AGENCY,
            modules : [
              {
                title: 'Dashboard',
                path: '/dashboardHome/dashboardStakeHolder',
                icon: <DashboardIcon />,
                order: 1,
                
            
              },
              {
                title: 'HelpDesk',
                path: '/dashboardHome/requests',
                icon: <AnnouncementIcon />,
                order: 2,
                children : [
                  {
                    title: 'Requests',
                    path: '/dashboardHome/requests',
                    icon: <AssessmentIcon />,
                  },
                  {
                    title: 'FAQs',
                    path: '/dashboardHome/faqs',
                    icon: <AssessmentIcon />,
                  },
                ]
              },
              {
                title: 'Demand',
                path: '/dashboardHome/workflowStatusList',
                icon: <AssessmentIcon />,
                order: 3,
            
              },
              {
                title: 'PIT',
                path: '/dashboardHome/trialScreen',
                icon: <AutoModeIcon />,
                order: 4,
                children:[
                  // {
                  //   title: "Home",
                  //   path: '/dashboardHome/trialScreen',
                  //   icon: <AutoModeIcon />,
                  // },
                  {
                    title: "POs",
                    path: '/dashboardHome/poList',
                    icon: <AutoModeIcon />,
                  },
                  {
                    title: "Weekly Schedule",
                    path: '/dashboardHome/GhtSchedule',
                    icon: <AutoModeIcon />,
                  },
                  {
                    title: "Invoices",
                    path: '/dashboardHome/invoiceList',
                    icon: <AutoModeIcon />,
                  },
                  // {
                  //   title: "Monthly PO",
                  //   path: '/dashboardHome/PoQtyApproval',
                  //   icon: <AutoModeIcon />,
                  // },
                ]
              },
              {
                title: 'Payment Status',
                path: '/dashboardHome/PaymentStatusStakeholderUser',
                icon: <PaymentIcon />,
                order: 5,
            
              },
            {
              title: 'Registration Details',
              path: '/dashboardHome/registrationDetails',
              icon: <HowToRegIcon />,
              order: 6,
          
            },
            {
              title: 'Resource',
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <BadgeIcon />,
              order: 7,
              children : [
                {
                  title: 'View Knowledge Management',
                  path: '/dashboardHome/viewKnowledgeManagement',
                  icon: <AssessmentIcon />,
                },
                {
                  title: 'Plantation Batch',
                  path: '/dashboardHome/plantationHome',
                  icon: <AssessmentIcon />,
                },
              ]
            },
          ],
            },

      {
        stakeholderType : STAKEHOLDERSUBTYPE.COOPERATIVE ,
        modules : [
          {
            title: 'Dashboard',
            path: '/dashboardHome/dashboardStakeHolder',
            icon: <DashboardIcon />,
            order: 1,
            
        
          },
          {
            title: 'HelpDesk',
            path: '/dashboardHome/requests',
            icon: <AnnouncementIcon />,
            order: 2,
            children : [
              {
                title: 'Requests',
                path: '/dashboardHome/requests',
                icon: <AssessmentIcon />,
              },
              {
                title: 'FAQs',
                path: '/dashboardHome/faqs',
                icon: <AssessmentIcon />,
              },
            ]
          },
          {
            title: 'Demand',
            path: '/dashboardHome/workflowStatusList',
            icon: <AssessmentIcon />,
            order: 3,
        
          },
          {
            title: 'PIT',
            path: '/dashboardHome/trialScreen',
            icon: <AutoModeIcon />,
            order: 4,
            children:[
              // {
              //   title: "Home",
              //   path: '/dashboardHome/trialScreen',
              //   icon: <AutoModeIcon />,
              // },
              {
                title: "POs",
                path: '/dashboardHome/poList',
                icon: <AutoModeIcon />,
              },
              {
                title: "Weekly Schedule",
                path: '/dashboardHome/GhtSchedule',
                icon: <AutoModeIcon />,
              },
              {
                title: "Invoices",
                path: '/dashboardHome/invoiceList',
                icon: <AutoModeIcon />,
              },
              // {
              //   title: "Monthly PO",
              //   path: '/dashboardHome/PoQtyApproval',
              //   icon: <AutoModeIcon />,
              // },
            ]
          },
          {
            title: 'Payment Status',
            path: '/dashboardHome/PaymentStatusStakeholderUser',
            icon: <PaymentIcon />,
            order: 5,
        
          },
        {
          title: 'Registration Details',
          path: '/dashboardHome/registrationMemberDetails',
          icon: <HowToRegIcon />,
          order: 6,
      
        },
        {
          title: 'Resource',
          path: '/dashboardHome/viewKnowledgeManagement',
          icon: <BadgeIcon />,
          order: 7,
          children : [
            {
              title: 'View Knowledge Management',
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <AssessmentIcon />,
            },
            {
              title: 'Plantation Batch',
              path: '/dashboardHome/plantationHome',
              icon: <AssessmentIcon />,
            },
          ]
        },
      ],
        },
        {
          stakeholderType : STAKEHOLDERSUBTYPE.FPO ,
          modules : [
            {
              title: 'Dashboard',
              path: '/dashboardHome/dashboardStakeHolder',
              icon: <DashboardIcon />,
              order: 1,
              
          
            },
            {
              title: 'HelpDesk',
              path: '/dashboardHome/requests',
              icon: <AnnouncementIcon />,
              order: 2,
              children : [
                {
                  title: 'Requests',
                  path: '/dashboardHome/requests',
                  icon: <AssessmentIcon />,
                },
                {
                  title: 'FAQs',
                  path: '/dashboardHome/faqs',
                  icon: <AssessmentIcon />,
                },
              ]
            },
            {
              title: 'Demand',
              path: '/dashboardHome/workflowStatusList',
              icon: <AssessmentIcon />,
              order: 3,
          
            },
            {
              title: 'PIT',
              path: '/dashboardHome/trialScreen',
              icon: <AutoModeIcon />,
              order: 4,
              children:[
                // {
                //   title: "Home",
                //   path: '/dashboardHome/trialScreen',
                //   icon: <AutoModeIcon />,
                // },
                {
                  title: "POs",
                  path: '/dashboardHome/poList',
                  icon: <AutoModeIcon />,
                },
                {
                  title: "Weekly Schedule",
                  path: '/dashboardHome/GhtSchedule',
                  icon: <AutoModeIcon />,
                },
                {
                  title: "Invoices",
                  path: '/dashboardHome/invoiceList',
                  icon: <AutoModeIcon />,
                },
                // {
                //   title: "Monthly PO",
                //   path: '/dashboardHome/PoQtyApproval',
                //   icon: <AutoModeIcon />,
                // },
              ]
            },
            {
              title: 'Payment Status',
              path: '/dashboardHome/PaymentStatusStakeholderUser',
              icon: <PaymentIcon />,
              order: 5,
          
            },
          {
            title: 'Registration Details',
            path: '/dashboardHome/registrationMemberDetails',
            icon: <HowToRegIcon />,
            order: 6,
        
          },
          {
            title: 'Resource',
            path: '/dashboardHome/viewKnowledgeManagement',
            icon: <BadgeIcon />,
            order: 7,
            children : [
              {
                title: 'View Knowledge Management',
                path: '/dashboardHome/viewKnowledgeManagement',
                icon: <AssessmentIcon />,
              },
              {
                title: 'Plantation Batch',
                path: '/dashboardHome/plantationHome',
                icon: <AssessmentIcon />,
              },
            ]
          },
        ],
          },
          {
            stakeholderType : STAKEHOLDERSUBTYPE.FPC ,
            modules : [
              {
                title: 'Dashboard',
                path: '/dashboardHome/dashboardStakeHolder',
                icon: <DashboardIcon />,
                order: 1,
                
            
              },
              {
                title: 'HelpDesk',
                path: '/dashboardHome/requests',
                icon: <AnnouncementIcon />,
                order: 2,
                children : [
                  {
                    title: 'Requests',
                    path: '/dashboardHome/requests',
                    icon: <AssessmentIcon />,
                  },
                  {
                    title: 'FAQs',
                    path: '/dashboardHome/faqs',
                    icon: <AssessmentIcon />,
                  },
                ]
              },
              {
                title: 'Demand',
                path: '/dashboardHome/workflowStatusList',
                icon: <AssessmentIcon />,
                order: 3,
            
              },
              {
                title: 'PIT',
                path: '/dashboardHome/trialScreen',
                icon: <AutoModeIcon />,
                order: 4,
                children:[
                  // {
                  //   title: "Home",
                  //   path: '/dashboardHome/trialScreen',
                  //   icon: <AutoModeIcon />,
                  // },
                  {
                    title: "POs",
                    path: '/dashboardHome/poList',
                    icon: <AutoModeIcon />,
                  },
                  {
                    title: "Weekly Schedule",
                    path: '/dashboardHome/GhtSchedule',
                    icon: <AutoModeIcon />,
                  },
                  {
                    title: "Invoices",
                    path: '/dashboardHome/invoiceList',
                    icon: <AutoModeIcon />,
                  },
                  // {
                  //   title: "Monthly PO",
                  //   path: '/dashboardHome/PoQtyApproval',
                  //   icon: <AutoModeIcon />,
                  // },
                ]
              },
              {
                title: 'Payment Status',
                path: '/dashboardHome/PaymentStatusStakeholderUser',
                icon: <PaymentIcon />,
                order: 5,
            
              },
            {
              title: 'Registration Details',
              path: '/dashboardHome/registrationMemberDetails',
              icon: <HowToRegIcon />,
              order: 6,
          
            },
            {
              title: 'Resource',
              path: '/dashboardHome/viewKnowledgeManagement',
              icon: <BadgeIcon />,
              order: 7,
              children : [
                {
                  title: 'View Knowledge Management',
                  path: '/dashboardHome/viewKnowledgeManagement',
                  icon: <AssessmentIcon />,
                },
                {
                  title: 'Plantation Batch',
                  path: '/dashboardHome/plantationHome',
                  icon: <AssessmentIcon />,
                },
              ]
            },
          ],
            },
            {
              stakeholderType : STAKEHOLDERSUBTYPE.SHG,
              modules : [
                {
                  title: 'Dashboard',
                  path: '/dashboardHome/dashboardStakeHolder',
                  icon: <DashboardIcon />,
                  order: 1,
                  
              
                },
                {
                  title: 'HelpDesk',
                  path: '/dashboardHome/requests',
                  icon: <AnnouncementIcon />,
                  order: 2,
                  children : [
                    {
                      title: 'Requests',
                      path: '/dashboardHome/requests',
                      icon: <AssessmentIcon />,
                    },
                    {
                      title: 'FAQs',
                      path: '/dashboardHome/faqs',
                      icon: <AssessmentIcon />,
                    },
                  ]
                },
                {
                  title: 'Demand',
                  path: '/dashboardHome/workflowStatusList',
                  icon: <AssessmentIcon />,
                  order: 3,
              
                },
                {
                  title: 'PIT',
                  path: '/dashboardHome/trialScreen',
                  icon: <AutoModeIcon />,
                  order: 4,
                  children:[
                    // {
                    //   title: "Home",
                    //   path: '/dashboardHome/trialScreen',
                    //   icon: <AutoModeIcon />,
                    // },
                    {
                      title: "POs",
                      path: '/dashboardHome/poList',
                      icon: <AutoModeIcon />,
                    },
                    {
                      title: "Weekly Schedule",
                      path: '/dashboardHome/GhtSchedule',
                      icon: <AutoModeIcon />,
                    },
                    {
                      title: "Invoices",
                      path: '/dashboardHome/invoiceList',
                      icon: <AutoModeIcon />,
                    },
                    // {
                    //   title: "Monthly PO",
                    //   path: '/dashboardHome/PoQtyApproval',
                    //   icon: <AutoModeIcon />,
                    // },
                  ]
                },
                {
                  title: 'Payment Status',
                  path: '/dashboardHome/PaymentStatusStakeholderUser',
                  icon: <PaymentIcon />,
                  order: 5,
              
                },
              {
                title: 'Registration Details',
                path: '/dashboardHome/registrationMemberDetails',
                icon: <HowToRegIcon />,
                order: 6,
            
              },
              {
                title: 'Resource',
                path: '/dashboardHome/viewKnowledgeManagement',
                icon: <BadgeIcon />,
                order: 7,
                children : [
                  {
                    title: 'View Knowledge Management',
                    path: '/dashboardHome/viewKnowledgeManagement',
                    icon: <AssessmentIcon />,
                  },
                  {
                    title: 'Plantation Batch',
                    path: '/dashboardHome/plantationHome',
                    icon: <AssessmentIcon />,
                  },
                ]
              },
            ],
              },
        {
          stakeholderType : STAKEHOLDERSUBTYPE.FOREST,
          modules : [
            {
              title: 'Dashboard',
              path: '/dashboardHome/dashboardStakeHolder',
              icon: <DashboardIcon />,
              order: 1,
              
          
            },
            {
              title: 'HelpDesk',
              path: '/dashboardHome/requests',
              icon: <AnnouncementIcon />,
              order: 2,
              children : [
                {
                  title: 'Requests',
                  path: '/dashboardHome/requests',
                  icon: <AssessmentIcon />,
                },
                {
                  title: 'FAQs',
                  path: '/dashboardHome/faqs',
                  icon: <AssessmentIcon />,
                },
              ]
            },
            {
              title: 'Demand',
              path: '/dashboardHome/workflowStatusList',
              icon: <AssessmentIcon />,
              order: 3,
          
            },
            {
              title: 'PIT',
              path: '/dashboardHome/trialScreen',
              icon: <AutoModeIcon />,
              order: 4,
              children:[
                // {
                //   title: "Home",
                //   path: '/dashboardHome/trialScreen',
                //   icon: <AutoModeIcon />,
                // },
                {
                  title: "POs",
                  path: '/dashboardHome/poList',
                  icon: <AutoModeIcon />,
                },
                {
                  title: "Weekly Schedule",
                  path: '/dashboardHome/GhtSchedule',
                  icon: <AutoModeIcon />,
                },
                {
                  title: "Invoices",
                  path: '/dashboardHome/invoiceList',
                  icon: <AutoModeIcon />,
                },
                // {
                //   title: "Monthly PO",
                //   path: '/dashboardHome/PoQtyApproval',
                //   icon: <AutoModeIcon />,
                // },
              ]
            },
            {
              title: 'Payment Status',
              path: '/dashboardHome/PaymentStatusStakeholderUser',
              icon: <PaymentIcon />,
              order: 5,
          
            },
          {
            title: 'Registration Details',
            path: '/dashboardHome/registrationDetailsForest',
            icon: <HowToRegIcon />,
            order: 6,
        
          },
          {
            title: 'Resource',
            path: '/dashboardHome/viewKnowledgeManagement',
            icon: <BadgeIcon />,
            order: 7,
            children : [
              {
                title: 'View Knowledge Management',
                path: '/dashboardHome/viewKnowledgeManagement',
                icon: <AssessmentIcon />,
              },
              {
                title: 'Plantation Batch',
                path: '/dashboardHome/plantationHome',
                icon: <AssessmentIcon />,
              },
            ]
          },
        ],
          },

];



